import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PanelModule } from '@elotech/angular-common';
import { FuncionarioSidebarComponent } from './funcionario-sidebar.component';
import { FuncionarioService } from '../../../funcionario/funcionario.service';
import { PipeModule } from '@elotech/angular-common';
import { BackConfirmModule } from '@elotech/angular-common';

@NgModule({
  imports: [
    CommonModule,
    PanelModule,
    FormsModule,
    ReactiveFormsModule,
    PipeModule,
    BackConfirmModule
  ],
  declarations: [FuncionarioSidebarComponent],
  exports: [FuncionarioSidebarComponent],
  providers: [FuncionarioService]
})
export class FuncionarioSidebarModule {
}
